import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import UserHeader from '../../component/reusable/UserHeader';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import BomOrderCard from '../../component/bomComps/BomOrderCard';
import BomOrderTab from '../../component/bomComps/BomOrderTab';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import { deleteexcessOrderThunk, exportexcessOrderThunk, getAllexcessOrderThunk, getexcessOrderStatisticsThunk, setexcessOrderFromDate, setexcessOrderPage, setexcessOrderSearch, setexcessOrderSelectedTab, setexcessOrderToDate } from '../../redux/excessOrderSlice';
import BomOrderFilter from '../../component/bomComps/BomOrderFilter';






function ExcessOrders() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    // Newest first by default; ascending only when picked from a column menu
    const [order, setOrder] = useState('desc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const deleteCategory = () => {
        dispatch(deleteexcessOrderThunk(selectedId))
        setIsModalOpen(false);

    }


    //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };


    const handleChange = (event, newValue) => {
        dispatch(setexcessOrderSelectedTab(newValue))
        setAllStatus('')
        dispatch(setexcessOrderPage(1))
        dispatch(setexcessOrderSearch(''))
        dispatch(setexcessOrderFromDate(''))
        dispatch(setexcessOrderToDate(''))
    };

    const { excess, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, orderStatistics } = useSelector((state) => state.excessOrder);
    const excessData = excess?.data
    const totalPages = excess?.totalPages
    const totalItems = excess?.totalItems
    const itemsPerPage = excess?.limit

    console.log(excessData);

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'DELIVERED' : "CANCELLED"

    //    console.log(excess);

    useEffect(() => {
        dispatch(getAllexcessOrderThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}&orderType=EXCESS`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    // Status values offered in the Status column menu (only on the "All" tab, the other tabs are already one status)
    const statusFilterOptions = [{ value: 'NEW', label: 'New' }, { value: 'DELIVERED', label: 'Delivered' }, { value: 'CANCELLED', label: 'Cancelled' }];

    const handleStatusFilter = (value) => {
        setAllStatus(value)
        dispatch(setexcessOrderPage(1))
    };

    // Date / Status column menus: pick descending / ascending explicitly and start again from page 1
    const handleColumnSort = (field, direction) => {
        setSortyBy(field)
        setOrder(direction)
        dispatch(setexcessOrderPage(1))
    };

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportexcessenq = async () => {
        const status = await dispatch(exportexcessOrderThunk(`?limit=${100000}&orderType=EXCESS`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "excess")
        }
    }



    useEffect(() => {
        dispatch(getexcessOrderStatisticsThunk(`?orderType=EXCESS`))
    }, [])

    return (
        <>
            <UserHeader
                index="excess Orders"
                root="Dashboard"
                exportData={exportexcessenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />

            <BomOrderCard orderStatistics={orderStatistics} />

            <Box>

                <BomOrderTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomOrderFilter
                    setAllStatus={setAllStatus}
                    search={search} selectedTab={selectedTab}
                    setOrderFromDate={setexcessOrderFromDate}
                    setOrderToDate={setexcessOrderToDate}
                    setSearch={setexcessOrderSearch}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {excessData?.length > 0 ?
                                    <Typography>
                                        <AllBomOrderTable
                                            bomData={excessData}
                                            page={page}
                                            setPage={setexcessOrderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            dateOrder={sortBy === 'createdAt' ? order : null}
                                            onDateSort={(direction) => handleColumnSort('createdAt', direction)}
                                            statusOrder={sortBy === 'status' ? order : null}
                                            onStatusSort={(direction) => handleColumnSort('status', direction)}
                                            statusFilterOptions={selectedTab === 0 ? statusFilterOptions : null}
                                            statusFilterValue={allStatus}
                                            onStatusFilterChange={handleStatusFilter}
                                            selectedTab={selectedTab}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/excess/excessOrderDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default ExcessOrders;
